const Vision = () => {
	return(
	<div className="section-full bg-repeat p-t100 p-b70">
		<div className="container">
			{/* <!-- TITLE START --> */}   
			<div className="section-head text-center">
				<h2><span className="site-text-primary">Mission </span>& Vision</h2>
				<div className="wt-separator-outer ">
					<div className="wt-separator style-icon">
						<i className="fa fa-leaf text-black"></i>
						<span className="separator-left site-bg-primary"></span>
						<span className="separator-right site-bg-primary"></span>
					</div>                            
				</div>				
			</div>
			{/* <!-- TITLE START --> */}	
			
			<p> A school needs clear direction and purpose. Strong mission and vision statements guide each decision, from curriculum development to student engagement strategies. These statements form the foundation of your school’s identity and help build trust with parents, students, and staff.</p>
			<p>Looking to create statements that show your educational institution’s values and goals? Here are outstanding examples from different types of schools that can spark ideas for your own business plan for schools. These carefully written statements show how schools share their purpose and future goals effectively.</p>			  
			<h3>Mission:</h3>
			<p>To foster academic excellence through personalized learning approaches while developing well-rounded individuals who demonstrate strong character and leadership skills. We focus on providing innovative educational experiences that prepare students for success in a connected society.</p>
			<h3>Vision:</h3>
			<p>To stand out as a leading educational institution known for developing independent thinkers, creative problem-solvers, and caring leaders who make meaningful contributions to their communities and beyond.</p>
		  
		</div>
	</div>
	);
};
export default Vision;